import React from 'react';
import YouTube, { Options, PlayerVars } from 'react-youtube';

import { getYouTubeVideoIdFromUrl } from 'utils';
import { InitPlayerFn } from '../../types';
import useYouTubeEmbedVideo from './useYouTubeEmbedVideo';

import s from './youTubeEmbedVideo.scss';

interface Props {
    // playerNodeId: string;
    autoplay?: boolean;
    url: string;
    initPlayer?: InitPlayerFn;
    togglePlayStatus: (isVideoPlaying: boolean) => void;
}

const YouTubeEmbedVideo: React.FC<Props> = ({
    // playerNodeId,
    autoplay,
    togglePlayStatus,
    initPlayer,
    url,
}) => {
    const { onPause, onPlay, onReady } = useYouTubeEmbedVideo({
        url,
        initPlayer,
        togglePlayStatus,
    });
    const videoId = getYouTubeVideoIdFromUrl(url);

    const playerVars: PlayerVars = {
        autoplay: autoplay ? 1 : 0,
        fs: 0,
    };

    const opts: Options = {
        width: '100%',
        height: '100%',
        playerVars,
    };

    return (
        <YouTube
            containerClassName={s.container}
            styleName={s.youtube}
            opts={opts}
            onReady={onReady}
            onPlay={onPlay}
            onPause={onPause}
            videoId={videoId}
        />
    );
};

export default React.memo(YouTubeEmbedVideo);
